import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getPaymentModeList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const CreditPaymentMethod = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  disable,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const periodLabel = dta =>
    dta?.period == 0
      ? "Immediate"
      : `${dta?.period} ${
          dta?.unit == "days"
            ? dta?.period > 1
              ? "Days"
              : "Day"
            : dta?.period > 1
            ? "Months"
            : "Month"
        }`

  const loadOptions = async () => {
    const data = await getPaymentModeList()
    setIsLoading(false)
    // The same credit period comes from several payment methods (Cheque/PDC/Credit…), which
    // made the dropdown repeat (Immediate ×3, 90 Days ×3). De-dupe by the period label and
    // sort ascending so each credit period appears once. (react-select still shows a saved
    // value's own label on edit, so existing selections are unaffected.)
    const seen = new Set()
    const response = (data?.data || [])
      .map(dta => ({ label: periodLabel(dta), value: dta.id, ...dta }))
      .filter(o => (seen.has(o.label) ? false : (seen.add(o.label), true)))
      .sort((a, b) => Number(a?.period || 0) - Number(b?.period || 0))

    setFetchResponse(response)
  }
  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
                <div className="css-placeholder">{placeholder || "Select"}</div>
              }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disable ? true : false}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          )
        }}
      />
    </div>
  )
}

export default CreditPaymentMethod
